import { c as _c } from "react/compiler-runtime";
import { usePathname } from 'next/navigation';
import { useMemo } from 'react';
import { SIDEBAR_ITEMS } from 'src/constants/menus';
import useRouteWithParams from 'src/hooks/useRouteWithParams';
import useFeatures from './useFeatures';
import useRouteDefs from './useRouteDefs';
import { MenuItem } from 'src/types/global';
import { useRouteNames } from './useRouteNames';
type ItemsOverrides = Record<string, MenuItem>;
const filterItemsByFeatureFlag = (items: MenuItem[], isEnabled: (feature: string, defaultValue?: boolean) => boolean): MenuItem[] => items.filter(item => !item.featureFlag || isEnabled(item.featureFlag, item.defaultFlagValue ?? true)).map(item => {
  if (!item.children) {
    return item;
  }
  return {
    ...item,
    children: filterItemsByFeatureFlag(item.children, isEnabled)
  };
}).filter(item => !item.children || item.children.length > 0 || !!item.path);
const useMenuItems = t0 => {
  const $ = _c(16);
  let t1;
  if ($[0] !== t0) {
    t1 = t0 === undefined ? {} : t0;
    $[0] = t0;
    $[1] = t1;
  } else {
    t1 = $[1];
  }
  const itemsOverrides = t1;
  const pathname = usePathname();
  const {
    updatePathWithParams
  } = useRouteWithParams();
  const {
    isEnabled
  } = useFeatures();
  const {
    getCurrentRouteDef
  } = useRouteDefs();
  const ROUTE_NAMES = useRouteNames();
  let t2;
  if ($[2] !== isEnabled) {
    t2 = filterItemsByFeatureFlag(SIDEBAR_ITEMS, isEnabled);
    $[2] = isEnabled;
    $[3] = t2;
  } else {
    t2 = $[3];
  }
  const enabledItems = t2;
  let t3;
  bb0: {
    if (!pathname) {
      t3 = "";
      break bb0;
    }
    let t4;
    if ($[4] !== getCurrentRouteDef || $[5] !== pathname) {
      t4 = getCurrentRouteDef(pathname).matched ? pathname : "";
      $[4] = getCurrentRouteDef;
      $[5] = pathname;
      $[6] = t4;
    } else {
      t4 = $[6];
    }
    t3 = t4;
  }
  const currentRoute = t3;
  let t4;
  bb1: {
    if (!enabledItems || enabledItems.length === 0) {
      let t5;
      if ($[7] === Symbol.for("react.memo_cache_sentinel")) {
        t5 = [];
        $[7] = t5;
      } else {
        t5 = $[7];
      }
      t4 = t5;
      break bb1;
    }
    let t5;
    if ($[8] !== ROUTE_NAMES || $[9] !== currentRoute || $[10] !== enabledItems || $[11] !== itemsOverrides || $[12] !== updatePathWithParams) {
      const mapItem = item => ({
        ...item,
        enabled: item.enabled !== false,
        path: updatePathWithParams(item.path || ""),
        name: item.name || ROUTE_NAMES[item.path as keyof typeof ROUTE_NAMES] || "",
        isActive: item.path ? item.matchPrefix ? currentRoute.startsWith(updatePathWithParams(item.path || "")) : currentRoute === updatePathWithParams(item.path || "") : false,
        ...(item.children ? {
          children: item.children.map(mapItem)
        } : {}),
        ...itemsOverrides[item.path || item.name || ""]
      });
      t5 = enabledItems.map(mapItem);
      $[8] = ROUTE_NAMES;
      $[9] = currentRoute;
      $[10] = enabledItems;
      $[11] = itemsOverrides;
      $[12] = updatePathWithParams;
      $[13] = t5;
    } else {
      t5 = $[13];
    }
    t4 = t5;
  }
  const menuItems = t4;
  let t5;
  if ($[14] !== menuItems) {
    t5 = {
      menuItems
    };
    $[14] = menuItems;
    $[15] = t5;
  } else {
    t5 = $[15];
  }
  return t5;
};
export default useMenuItems;